import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const RecordManagementPage = () => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchRecords = async () => {
    setLoading(true);
    try {
      const res = await axios.get('/api/records/all');
      setRecords(res.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchRecords(); }, []);

  if (loading) return <p>Loading records...</p>;
  if (error) return <p className="text-red-500">Error: {error}</p>;

  return (
    <div className="p-6">
      <h1 className="text-2xl mb-4">Records</h1>
      <Link to="/dashboard/admin/record/new" className="text-blue-500">+ New Record</Link>
      <table className="min-w-full mt-4 border">
        <thead>
          <tr>
            <th className="border p-2">User</th>
            <th className="border p-2">Quiz</th>
            <th className="border p-2">Score</th>
            <th className="border p-2">Date</th>
            <th className="border p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {records.map(r => (
            <tr key={r.id}>
              <td className="border p-2">{r.User?.email || r.userId}</td>
              <td className="border p-2">{r.Quiz?.title || r.quizId}</td>
              <td className="border p-2">{r.score}</td>
              <td className="border p-2">{new Date(r.createdAt).toLocaleDateString()}</td>
              <td className="border p-2">
                <Link to={`/dashboard/admin/record/${r.id}/edit`} className="text-green-500 mr-2">Edit</Link>
                <button onClick={async () => {
                    if (window.confirm('Delete this record?')) {
                      try { await axios.delete(`/api/records/${r.id}`); fetchRecords(); }
                      catch (err) { alert(err.response?.data?.error || 'Delete failed'); }
                    }
                  }} className="text-red-500">Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RecordManagementPage;
